// extracted by mini-css-extract-plugin
module.exports = {"flexItem":"header_flexItem__BIzwu","brandingText":"header_brandingText__23m-2","welcomeText":"header_welcomeText__1FETJ","disabledLink":"header_disabledLink__UgvXY"};